module.exports = __webpack_public_path__ + "static/media/pasamosagosto2.e510aa15.jpg";